/* eslint-disable*/
import React, { useState, useEffect } from "react";
import { Button, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, UncontrolledTooltip, FormGroup, Label, ModalBody, ModalHeader } from "reactstrap";
import { BlurSpinner } from "../../../components/BlurSpinner";
import SpinnerButton from "../../../components/Button";
import ConfirmModal from "../Tabs/ConfirmModal";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { Edit } from "react-feather";
import { handleErrors } from "../../../services/handleErrors";
import { getUserId } from "../../../utils/authUtils";
import { patchProcedimiento, postProcedimiento } from "../../../services/procedimientoService";
import modulos from "../../../mocks/modulos";
import { useAuth } from "../../../context/AuthContext";

const ModalTabs = ({ toggle, procedimientos, clientId, isAdmin, isOwner }) => {
  const { currentUser } = useAuth();
  console.log(`Current user: ${currentUser.user.itemId} - Procedimiento: ${procedimientos.createdBy}`, currentUser);
  const isWritable =
    isAdmin ||
    (isOwner && !procedimientos.createdBy) ||
    (currentUser && currentUser.user && currentUser.user.Pi && currentUser.user.Pi.itemId === procedimientos.createdBy);
  const [inputEnabled, setInputEnabled] = useState(true);
  const [confirmarModal, setConfirmarModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [changes, setChanges] = useState({
    cobranzas: false,
    facturacion: false,
    members: false,
    nomina: false,
    operacion: false,
    particularidades: false,
    otrasAreas: false,
  });

  const formik = useFormik({
    initialValues: {
      title: procedimientos.title || "",
      cobranzas: procedimientos.cobranzas || "",
      facturacion: procedimientos.facturacion || "",
      members: procedimientos.members || "",
      nomina: procedimientos.nomina || "",
      operacion: procedimientos.operacion || "",
      particularidades: procedimientos.particularidades || "",
      otrasAreas: procedimientos.otrasAreas || "",
      id: procedimientos.id || null,
    },
    onSubmit: async (procedimiento) => {
      try {
        setIsLoading(true);
        const procedimientoBody = {
          title: procedimiento.title || "",
          cobranzas: procedimiento.cobranzas || "",
          facturacion: procedimiento.facturacion || "",
          members: procedimiento.members || "",
          nomina: procedimiento.nomina || "",
          operacion: procedimiento.operacion || "",
          particularidades: procedimiento.particularidades || "",
          otrasAreas: procedimiento.otrasAreas || "",
          id: procedimiento.id || null,
        };
        const client = clientId;
        const res =
          procedimientoBody.id !== null && client !== undefined
            ? await patchProcedimiento(client, procedimientoBody)
            : await postProcedimiento(client, procedimientoBody);
        setConfirmarModal(false);
        setChanges({ cobranzas: false, facturacion: false, members: false, nomina: false, operacion: false, particularidades: false, otrasAreas: false });
        toast.success("Procedimiento Actualizado");
        toggle();
        setIsLoading(false);
      } catch (error) {
        handleErrors(error);
      }
    },
  });
  const handleBlur = (value) => {
    if (procedimientos) {
      if (formik.values[value] !== procedimientos[value]) {
        setChanges((prevState) => ({ ...prevState, [value]: true }));
      } else {
        setChanges((prevState) => ({ ...prevState, [value]: false }));
        return;
      }
    }
    if (formik.values[value] != null) {
      setChanges((prevState) => ({ ...prevState, [value]: true }));
    } else {
      setChanges((prevState) => ({ ...prevState, [value]: false }));
    }
  };
  useEffect(async () => {
    try {
      setIsLoading(false);
    } catch (error) {
      handleErrors(error);
    }
  }, []);

  return (
    <>
      {confirmarModal && <ConfirmModal toggle={() => setConfirmarModal(!confirmarModal)} handleSubmitArea={formik.handleSubmit} />}

      <FormGroup className="w-100 m-0 pl-4 pt-4 pb-0 pr-4 d-flex flex-row justify-content-between align-items-center">
        <input
          disabled={inputEnabled}
          name="title"
          onBlur={() => handleBlur("title")}
          onChange={formik.handleChange}
          placeholder="Título"
          value={formik.values.title}
          className={inputEnabled ? " input_procedimientos_title" : "input_procedimientos_title_enabled"}
        ></input>

        {isWritable && (
          <Edit
            size="16px"
            color=" #c93b2a"
            onClick={() => {
              setInputEnabled(!inputEnabled);
            }}
            style={{ cursor: "pointer" }}
          />
        )}

        <Button size="lg" close onClick={toggle}>
          x
        </Button>
      </FormGroup>
      {changes.title ? (
        <div style={{ height: "15px" }} className=" pl-3 input-feedback d-flex flex-column align-items-start">
          Cambios por guardar en el titulo
        </div>
      ) : (
        <div style={{ height: "15px" }} />
      )}
      <ModalBody>
        <BlurSpinner isLoading={isLoading}>
          {procedimientos && (
            <FormGroup className="w-100 p-2">
              <FormGroup>
                <div className="form-group" style={{ margin: 0 }}>
                  <Label htmlFor="members" style={{ fontWeight: "bolder" }} className="col-form-label fw-bold pt-0 w-100 ">
                    Miembros
                  </Label>
                  <textarea
                    name="members"
                    onBlur={() => handleBlur("members")}
                    rows={2}
                    className="w-100"
                    value={formik.values.members}
                    onChange={formik.handleChange}
                    disabled={!isWritable}
                  ></textarea>
                  {changes.members ? (
                    <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                      Cambios por guardar
                    </div>
                  ) : (
                    <div style={{ height: "15px", padding: "0px" }} />
                  )}
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <Label htmlFor="particularidades" style={{ fontWeight: "bolder" }} className="col-form-label fw-bold pt-0 w-100">
                    Particularidades
                  </Label>
                  <textarea
                    name="particularidades"
                    onBlur={() => handleBlur("particularidades")}
                    rows={2}
                    className="w-100"
                    value={formik.values.particularidades}
                    onChange={formik.handleChange}
                    disabled={!isWritable}
                  ></textarea>
                  {changes.particularidades ? (
                    <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                      Cambios por guardar
                    </div>
                  ) : (
                    <div style={{ height: "15px", padding: "0px" }} />
                  )}
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <Label htmlFor="operacion" style={{ fontWeight: "bolder" }} className="col-form-label fw-bold pt-0 w-100">
                    Operación
                  </Label>
                  <textarea
                    name="operacion"
                    onBlur={() => handleBlur("operacion")}
                    rows={2}
                    className="w-100"
                    value={formik.values.operacion}
                    onChange={formik.handleChange}
                    disabled={!isWritable}
                  ></textarea>
                  {changes.operacion ? (
                    <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                      Cambios por guardar
                    </div>
                  ) : (
                    <div style={{ height: "15px", padding: "0px" }} />
                  )}
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <Label htmlFor="nomina" style={{ fontWeight: "bolder" }} className="col-form-label fw-bold pt-0 w-100">
                    Nómina
                  </Label>
                  <textarea
                    name="nomina"
                    onBlur={() => handleBlur("nomina")}
                    rows={2}
                    className="w-100"
                    value={formik.values.nomina}
                    onChange={formik.handleChange}
                    disabled={!isWritable}
                  ></textarea>
                  {changes.nomina ? (
                    <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                      Cambios por guardar
                    </div>
                  ) : (
                    <div style={{ height: "15px", padding: "0px" }} />
                  )}
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <Label htmlFor="facturacion" style={{ fontWeight: "bolder" }} className="col-form-label fw-bold pt-0 w-100">
                    Facturación
                  </Label>
                  <textarea
                    name="facturacion"
                    onBlur={() => handleBlur("facturacion")}
                    value={formik.values.facturacion}
                    onChange={formik.handleChange}
                    rows={2}
                    className="w-100"
                    disabled={!isWritable}
                  ></textarea>
                  {changes.facturacion ? (
                    <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                      Cambios por guardar
                    </div>
                  ) : (
                    <div style={{ height: "15px", padding: "0px" }} />
                  )}
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <Label htmlFor="cobranzas" style={{ fontWeight: "bolder" }} className="col-form-label pt-0 w-100">
                    Cobranzas
                  </Label>
                  <textarea
                    name="cobranzas"
                    onBlur={() => handleBlur("cobranzas")}
                    value={formik.values.cobranzas}
                    onChange={formik.handleChange}
                    rows={2}
                    className="w-100"
                    disabled={!isWritable}
                  ></textarea>
                  {changes.cobranzas ? (
                    <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                      Cambios por guardar
                    </div>
                  ) : (
                    <div style={{ height: "15px", padding: "0px" }} />
                  )}
                </div>

                <div className="form-group" style={{ margin: 0 }}>
                  <Label htmlFor="otras areas" style={{ fontWeight: "bolder" }} className="col-form-label fw-bold pt-0 w-100">
                    Otras Areas
                  </Label>
                  <textarea
                    name="otrasAreas"
                    onBlur={() => handleBlur("otrasAreas")}
                    rows={2}
                    className="w-100"
                    value={formik.values.otrasAreas}
                    onChange={formik.handleChange}
                    disabled={!isWritable}
                  ></textarea>
                  {changes.otrasAreas ? (
                    <div style={{ height: "15px", padding: "0px" }} className="input-feedback d-flex flex-column align-items-end">
                      Cambios por guardar
                    </div>
                  ) : (
                    <div style={{ height: "15px", padding: "0px" }} />
                  )}
                </div>
              </FormGroup>
              <FormGroup className="mt-3 px-3 w-100 d-flex flex-column align-items-end ">
                {isWritable && (
                  <SpinnerButton className="btn btn-primary btn-block" isLoading={isLoading} disabled={false} onClick={() => setConfirmarModal(!confirmarModal)}>
                    Guardar Cambios
                  </SpinnerButton>
                )}
              </FormGroup>
            </FormGroup>
          )}
        </BlurSpinner>
      </ModalBody>
    </>
  );
};

export default ModalTabs;
